/* eslint-disable max-lines */
import styled from '@emotion/styled';
import { theme } from '../../../theme';
import ChevronDown from '../../../assets/chevron-down.svg';
import { StyledInputRoot } from '../text-input';
export const StyledPhoneInput = styled(StyledInputRoot) `
	.PhoneInput {
		width: 100%;
	}
	.PhoneInput input {
		all: unset;
		flex-grow: 1;
		flex-shrink: 1;
		padding: 0.625rem 0.75rem 0.625rem 1rem;
		position: relative;
		color: inherit;
		background-color: inherit;
	}

	// Container around flag and arrow
	.PhoneInputCountry {
		padding: 0.625rem 10px 0.625rem 1rem;
		height: 100%;
		margin-right: 0;
		flex-grow: 0;

		/* border-right: 1px solid ${theme.colors.LM_NU30}; */
		border-radius: ${theme.radii.radii30} 0 0 ${theme.radii.radii30} !important;
		/* !important on background-color to override the hover/active/focus of the parent */
		background-color: rgba(10, 24, 43, 0.03) !important;
	}

	// The actual select element
	.PhoneInputCountrySelect {
	}

	// The flag icon
	.PhoneInputCountryIcon {
	}

	// Div containing the arrow
	.PhoneInputCountrySelectArrow {
		content: url("${ChevronDown}");
		padding: 0;
		transform: none;
	}

	// CSS Vars
	--PhoneInputCountryFlag-borderColor--focus: ${theme.colors.LM_NU100};
	--PhoneInputCountrySelectArrow-color--focus: ${theme.colors.LM_NU100};
	--PhoneInputCountrySelectArrow-width: 1.5rem;
	--PhoneInputCountrySelectArrow-opacity: 1;
	--PhoneInputCountryFlag-borderOpacity: 1;
	--PhoneInputCountrySelectArrow-borderWidth: 0;
	--PhoneInputCountrySelectArrow-marginLeft: 3px;
	--PhoneInputCountryFlag-borderWidth: 0.5px;
`;
//# sourceMappingURL=PhoneNumberInput.styled.js.map